import { SIZE_THUMBNAIL_OPTIONS } from '@/shared/model';

/**
 * The four report-wide default/config literals `Recoil/index.ts` exported next
 * to its (dead) atoms. Single definition: `reportStore.ts` held byte-identical
 * private copies of all four and now imports them from here.
 */
export const defaultControlModalValue = {
  isShowIncludedStrips: false,
  isShowChangeDurationButtonType: false,
  isShowChangeDurationSelectedInfo: false,
  isShowAddNewEvent: false,
  isShowNewEvents: false,
  isShowChangeTypeBulk: false,
  isShowChangeTypeSingle: false,
  isShowChangeAfibAvgHr: false,
  isShowChangeDailyAfibHr: false,
  isShowAddEcgBookmark: false,
  isShowSwapTemplate: false,
  isShowSwapAllTemplateByPage: false,
  isShowSwapAllTemplateById: false,
};

export const SIZE_BEAT_THUMBNAIL = {
  [SIZE_THUMBNAIL_OPTIONS.SMALL]: {
    name: SIZE_THUMBNAIL_OPTIONS.SMALL,
    width: 235,
    height: 58.9,
  },
  [SIZE_THUMBNAIL_OPTIONS.MEDIUM]: {
    name: SIZE_THUMBNAIL_OPTIONS.MEDIUM,
    width: 334,
    height: 83.4,
  },
  [SIZE_THUMBNAIL_OPTIONS.LARGE]: {
    name: SIZE_THUMBNAIL_OPTIONS.LARGE,
    width: 420,
    height: 105,
  },
};

export const SIZE_EVENT_THUMBNAIL = {
  [SIZE_THUMBNAIL_OPTIONS.SMALL]: {
    name: SIZE_THUMBNAIL_OPTIONS.SMALL,
    width: 415,
    height: 87.1,
  },
  [SIZE_THUMBNAIL_OPTIONS.MEDIUM]: {
    name: SIZE_THUMBNAIL_OPTIONS.MEDIUM,
    width: 556,
    height: 111,
  },
  [SIZE_THUMBNAIL_OPTIONS.LARGE]: {
    name: SIZE_THUMBNAIL_OPTIONS.LARGE,
    width: 800,
    height: 151,
  },
};

export const defaultEventOptions = {
  eventNewsState: [] as any[],
  eventChangesState: [] as any[],
  eventOthersState: [] as any[],
};
